var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fileUploadCardIcon",
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.75v7.25a2.2 2.2 0 1 0 4.4 0v-4.1a3.85 3.85 0 1 0-7.7 0v5.35",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.25h10.75l4-4h2.75v17.25a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V16.25a2 2 0 0 1 2-2h.5z",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25l4-4",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.65,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 23.5h11.5M12.25 26.5h11.5M12.25 29.5h8",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.65,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.372b349e0d414b4aaa65d713cdd28e1d.svg";
export { ForwardRef as ReactComponent };